import { createContext, useContext, useSyncExternalStore, type ReactNode } from "react";
import { ApplicationActions } from "./domain/engine";
import type { MarketplaceState } from "./domain/types";

const ActionsContext = createContext<ApplicationActions | null>(null);

export function ActionsProvider({ actions, children }: { actions: ApplicationActions; children: ReactNode }) {
  return <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>;
}

export function useActions(): ApplicationActions {
  const actions = useContext(ActionsContext);
  if (!actions) throw new Error("Productist actions are not available.");
  return actions;
}

export function useMarketplaceState(): MarketplaceState {
  const actions = useActions();
  return useSyncExternalStore(actions.subscribe, actions.getState, actions.getState);
}
